import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { authLogin, getStoredToken } from "../../api/http";

type LoginPayload = {
  username: string;
  password: string;
};

type AuthState = {
  token: string | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
};

const initialState: AuthState = {
  token: getStoredToken(),
  isAuthenticated: !!getStoredToken(),
  loading: false,
  error: null,
};

export const loginAdmin = createAsyncThunk<string, LoginPayload, { rejectValue: string }>(
  "auth/loginAdmin",
  async (payload, { rejectWithValue }) => {
    try {
      return await authLogin(payload.username, payload.password);
    } catch (error) {
      const message = error instanceof Error ? error.message : "로그인에 실패했습니다.";
      return rejectWithValue(message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout(state) {
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
      localStorage.removeItem("admin_access_token");
    },
    hydrateToken(state) {
      const token = getStoredToken();
      state.token = token;
      state.isAuthenticated = !!token;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload;
        state.isAuthenticated = true;
        localStorage.setItem("admin_access_token", action.payload);
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? "로그인에 실패했습니다.";
      });
  },
});

export const { logout, hydrateToken } = authSlice.actions;
export default authSlice.reducer;
